<template>
  <div :class="{ 'timer-picker_active': active, 'date-picker-wrap': true}" @click="showPicker">
    <span v-if="value" class="time-picker-text">{{ value }}</span>
    <span v-else class="time-picker-placeholder">{{ _placeholder }}</span>
  </div>
</template>

<script>

export default {
  props: {
    disabled: {},
    value: {},
    autoPop: {},
    placeholder: {},
    min: {},
    max: {},
    startColumn: {},
    columnCount: {},
    format: {},
    title: {},
    subtitle: {},
    cancelTxt: {},
    confirmTxt: {},
    swipeTime: {},
    visible: {},
    maskClosable: {},
    zIndex: {}
  },
  data () {
    return {active: false}
  },
  created () {
    this.picker = this.$createDatePicker({
      $props: {
        value: new Date(),
        min: new Date(2010, 1, 1),
        max: new Date(2040, 12, 30),
        startColumn: 'startColumn',
        columnCount: 'columnCount',
        format: { year: 'YYYY', month: 'MM', date: 'DD' },
        title: 'title',
        subtitle: 'subtitle',
        cancelTxt: 'cancelTxt',
        confirmTxt: 'confirmTxt',
        swipeTime: 'swipeTime',
        visible: 'visible',
        maskClosable: 'maskClosable',
        zIndex: 'zIndex'
      },
      $events: {
        select: 'selectHandler',
        cancel: this.hided
      }
    })
    this.autoPop && this.showPicker()
  },
  methods: {
    showPicker () {
      if (this.disabled) {
        return
      }
      this.picker.show()
      this.active = true
    },
    hided () {
      this.active = false
    },
    selectHandler (selectedVal, selectedIndex, selectedText) {
      this.hided()
      console.log('[log] selectVal =>', selectedVal)
      // const [year, month, day, hour, minutes, second] = selectedText || []
      // const date = [year, month, day]
      const date = selectedText.join('-')
      if (date !== this.value) {
        this.$emit('input', date)
        this.$emit('change', date)
      }
    }
  },
  computed: {
    _placeholder () {
      return this.placeholder || ''
    }
  },
  watch: {
    value (newValue, oldValue) {
      if (oldValue !== newValue) {

      }
    }
  }
}
</script>
<style lang="scss">

</style>
